import { calculateConcreteWeight, numberWithCommas, getRecommendedDumpsterTitleByTons } from '../../components/calculator/calculations'

export default function concreteCalculator (calculatorForm, calculatorEstimatedWeightPanel, calculatorResultsPanel, calculatorRecommendedDumpsterTitle, calculatorRecommendedDumpsterImage, toggleResults) {
  const concreteCalculatorSqFtInput = calculatorForm.querySelector('[data-js-concrete-calculator-sq-ft-input]')
  const concreteCalculatorThicknessInput = calculatorForm.querySelector('[data-js-concrete-calculator-thickness-input]')

  calculatorForm.addEventListener('submit', calculateConcreteResults)

  function calculateConcreteResults (event) {
    event.preventDefault()
    const { pounds, tons } = calculateConcreteWeight(concreteCalculatorSqFtInput.value, concreteCalculatorThicknessInput.value)
    toggleResults()
    calculatorEstimatedWeightPanel.children[0].innerText = `${numberWithCommas(pounds)} lbs or ${tons} ton(s)`

    calculatorRecommendedDumpsterTitle.innerText = getRecommendedDumpsterTitleByTons(tons)
  }
}
